export function queryCdnData() {
  return new Promise((resolve, reject) => {
    // 拉取配置
    const isTest = location.href.indexOf('test') > -1;
    fetch('/api/rpc/rail.MarsDatasetService.GetDatasets', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        schemas: [{ schema_id: isTest ? 203 : 36, version: 0 }]
      })
    })
      .then((response) => response.json())
      .then((data) => {
        try {
          if (data.result && data.result.error_code === 0) {
            const cdnUrl = data.schema_datasets[0].datasets[0].cdn_url;
            if (cdnUrl) {
              // 拉取cdn
              const mmmUrl = cdnUrl;
              fetch(mmmUrl)
                .then((response) => response.json())
                .then((res) => {
                  if (res.buyLinkList) {
                    resolve(res.buyLinkList);
                  } else {
                    reject();
                  }
                })
                .catch(() => {
                  reject();
                });
            } else {
              reject();
            }
          }
        } catch (err) {
          reject();
        }
      })
      .catch(() => {
        reject();
      });
  });
}

export function checkWeixinBrowser() {
  const ua = navigator.userAgent;
  const str = ua.match(/MicroMessenger/i);
  if (str && str[0].toLocaleLowerCase() == 'micromessenger') {
    return true;
  }
  return false;
}

export const buyLinkList = {
  wx: require('/assets/img/shop.png'),
  jd: 'https://item.jd.com/100044988195.html',
  tm:
    'https://detail.tmall.com/item.htm?id=687195779723&spm=a212k0.12153887.0.0.4d7c687d9e2rcH&skuId=4896718897000'
};
